import axios from 'axios';
import { Fragment, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { BASE_URL } from '../../../Configuration/baseUrls';
import stylez from './ResetPWD.module.css';

const ResetPassword = () => {
  const [password, setPassword] = useState();
  const [validUrl, setValidUrl] = useState(false);
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');
  const params = useParams();

  const url = `${BASE_URL}user/${params.id}/password-reset/${params.token}`;
  // useEffect(() => {
  //   const verifyURL = async () => {
  //     try {
  //       await axios.get(url);
  //       console.log('');
  //       setValidUrl(true);
  //     } catch (error) {
  //       setValidUrl(false);
  //     }
  //   };
  //   verifyURL();
  // }, [params, url]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await axios.post(url, { password });
      setMsg(data.message);
      setError('');
      window.location = '/login';
    } catch (error) {
      if (
        error.response &&
        error.response.status >= 400 &&
        error.response.status <= 500
      ) {
        setError(error.response.data.message);
      }
    }
  };
  return (
    <Fragment>
      <div className={stylez.loginContainer}>
        <div className={stylez.login}>
          <h1>Add New Password</h1>
          <input
            type='password'
            placeholder='Password'
            name='password'
            onChange={(e) => setPassword(e.target.value)}
            value={password}
            required
          />
          {error && <div>{error}</div>}
          {msg && <div>{msg}</div>}
          <button className={stylez.submitBtn} onClick={handleSubmit}>
            Submit
          </button>
        </div>
      </div>
    </Fragment>
  );
};
export default ResetPassword;
